export default "__VITE_ASSET__BJ4R7zLY__"